import React, { FC } from 'react';

import { useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';
import { Icon, IconTypes } from '@eika/icon';

import RowLink from '../../components/AccountDetailsView/RowLink';
import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';

import '../Settings/Settings.scss';
import './AboutApp.scss';

const AboutApp: FC = () => {
    const translate = useTranslation();
    const { thirdPartyDependenciesLink, privacyLink } = useConfig();
    const { appVersion } = useReactNativeProps();
    return (
        <>
            <Content>
                {appVersion && (
                    <div className="settings__list-item settings__list-item-row about-app__app-version">
                        {translate.aboutApp.version} <span className="about-app__app-version-value">{appVersion}</span>
                    </div>
                )}
                {thirdPartyDependenciesLink?.url && (
                    <RowLink
                        className="settings__list-item settings__list-item-row"
                        href={thirdPartyDependenciesLink.url}
                    >
                        {translate.aboutApp.thirdPartyLicenses}
                        <Icon type={IconTypes.LITEN_PIL_HOEYRE} />
                    </RowLink>
                )}
                {privacyLink?.url && (
                    <RowLink className="settings__list-item settings__list-item-row" href={privacyLink.url}>
                        {translate.aboutApp.privacy}
                        <Icon type={IconTypes.LITEN_PIL_HOEYRE} />
                    </RowLink>
                )}
            </Content>
        </>
    );
};

export default AboutApp;
